
(function(){
  function setup(root){
    if(root.dataset.msInitialized==="true") return;
    root.dataset.msInitialized="true";
    const image=root.querySelector("[data-ms-main-image]");
    const zoom=root.querySelector("[data-ms-image-link]");
    root.querySelectorAll("[data-ms-thumb]").forEach(function(button){
      button.addEventListener("click",function(){
        const src=button.dataset.image;
        if(!src||!image) return;
        image.src=src;
        image.alt=button.dataset.alt||image.alt;
        if(zoom) zoom.href=src;
        root.querySelectorAll("[data-ms-thumb]").forEach(function(b){b.setAttribute("aria-pressed","false");});
        button.setAttribute("aria-pressed","true");
      });
    });
    const qty=root.querySelector("[data-ms-qty]");
    root.querySelectorAll("[data-ms-qty-delta]").forEach(function(button){
      button.addEventListener("click",function(){
        if(!qty) return;
        let current=parseInt(qty.value,10)||1;
        qty.value=String(Math.max(parseInt(qty.min,10)||1,current+Number(button.dataset.msQtyDelta)));
        qty.dispatchEvent(new Event("change",{bubbles:true}));
      });
    });
    const tabs=root.querySelectorAll("[data-ms-tab]");
    const panels=root.querySelectorAll("[data-ms-panel]");
    tabs.forEach(function(tab){
      tab.addEventListener("click",function(){
        tabs.forEach(function(t){t.setAttribute("aria-selected",String(t===tab));t.tabIndex=t===tab?0:-1;});
        panels.forEach(function(p){p.hidden=p.id!==tab.getAttribute("aria-controls");});
      });
    });
  }
  function init(){document.querySelectorAll("[data-ms-serum-page]").forEach(setup);}
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init);
  else init();
  document.addEventListener("shopify:section:load",init);
})();